/*!
 * Music Forecast — Saved Records v1.1
 * Browser-local wantlist. Event delegation keeps it working after soft nav/filter/sort.
 */
(function(){
  'use strict';
  if(window.__mfSaved) return;
  window.__mfSaved=true;

  var KEY='mf:saved:v1', MAX=100;
  var drawer=document.getElementById('mf-saved');
  var list=drawer && drawer.querySelector('[data-mf-saved-list]');
  var closeBtn=drawer && drawer.querySelector('.mf-saved__close');
  var opener=null;

  function read(){
    try{
      var v=JSON.parse(localStorage.getItem(KEY)||'[]');
      return Array.isArray(v)?v:[];
    }catch(e){return [];}
  }
  function write(items){
    try{localStorage.setItem(KEY,JSON.stringify(items.slice(0,MAX)));}catch(e){}
  }
  function esc(v){
    return String(v==null?'':v).replace(/[&<>"']/g,function(ch){return({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[ch];});
  }
  function itemFrom(btn){
    return {
      handle:btn.getAttribute('data-handle')||'',
      title:btn.getAttribute('data-title')||'',
      artist:btn.getAttribute('data-artist')||'',
      name:btn.getAttribute('data-name')||'',
      label:btn.getAttribute('data-label')||'',
      selected:btn.getAttribute('data-selected')==='1',
      url:btn.getAttribute('data-url')||'',
      image:btn.getAttribute('data-image')||'',
      listen:btn.getAttribute('data-listen')||'',
      variantId:btn.getAttribute('data-variant-id')||'',
      available:btn.getAttribute('data-available')==='1'
    };
  }
  function isSaved(handle,items){
    return items.some(function(x){return x && x.handle===handle;});
  }
  function enrichFromDOM(items){
    var changed=false;
    document.querySelectorAll('[data-mf-save]').forEach(function(btn){
      var handle=btn.getAttribute('data-handle')||'';
      if(!handle) return;
      var item=items.find(function(x){return x && x.handle===handle;});
      if(!item) return;
      var variant=btn.getAttribute('data-variant-id')||'';
      var available=btn.getAttribute('data-available');
      if(variant && String(item.variantId||'')!==variant){item.variantId=variant;changed=true;}
      if(available!==null){
        var next=available==='1';
        if(item.available!==next){item.available=next;changed=true;}
      }
    });
    if(changed) write(items);
    return items;
  }
  function syncButtons(){
    var items=enrichFromDOM(read());
    document.querySelectorAll('[data-mf-save]').forEach(function(btn){
      var on=isSaved(btn.getAttribute('data-handle'),items);
      btn.setAttribute('aria-pressed',on?'true':'false');
      var txt=btn.querySelector('.mf-save__text');
      if(txt) txt.textContent=on?'SAVED':'SAVE';
    });
    document.querySelectorAll('[data-mf-saved-count]').forEach(function(el){el.textContent=items.length;});
    document.querySelectorAll('[data-mf-saved-drawer-count]').forEach(function(el){el.textContent=items.length?'('+items.length+')':'';});
    var requestWrap=drawer && drawer.querySelector('[data-mf-saved-request-wrap]');
    if(requestWrap) requestWrap.hidden=!items.length;
  }
  function toggle(btn){
    var item=itemFrom(btn), items=read();
    if(!item.handle) return;
    var idx=items.findIndex(function(x){return x && x.handle===item.handle;});
    if(idx>=0) items.splice(idx,1);
    else items.unshift(item);
    write(items);
    syncButtons();
    if(drawer && drawer.classList.contains('is-open')) render();
  }
  function remove(handle){
    write(read().filter(function(x){return x && x.handle!==handle;}));
    syncButtons(); render();
  }
  function productJsonUrl(item){
    var url=(item.url||'').split('?')[0].replace(/\/$/,'');
    return url ? url+'.js' : '';
  }
  function hydrateItem(item){
    if(!item || item.variantId || item.hydrating) return Promise.resolve(false);
    var url=productJsonUrl(item);
    if(!url) return Promise.resolve(false);
    item.hydrating=true;
    return fetch(url,{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(res){if(!res.ok) throw new Error('product '+res.status);return res.json();})
      .then(function(product){
        var variants=product && product.variants || [];
        var variant=variants.find(function(v){return v.available;}) || variants[0];
        if(!variant) return false;
        item.variantId=String(variant.id||'');
        item.available=!!variant.available;
        delete item.hydrating;
        return true;
      })
      .catch(function(){delete item.hydrating;return false;});
  }
  function hydrateMissing(items){
    var missing=items.filter(function(x){return x && !x.variantId;});
    if(!missing.length) return;
    Promise.all(missing.map(hydrateItem)).then(function(results){
      if(!results.some(Boolean)) return;
      write(items);
      render();
    });
  }
  function cartControl(x){
    if(!x.variantId) return '<span class="mf-saved__cart mf-saved__cart--loading" aria-hidden="true"></span>';
    if(x.available===false) {
      if(!x.url || !x.handle) return '<span class="mf-saved__cart mf-saved__cart--sold">SOLD OUT</span>';
      var label=document.documentElement.lang.indexOf('ja')===0 ? '入荷通知を開く: ' : 'Open restock alert for ';
      return '<a class="mf-saved__cart mf-saved__cart--restock" href="'+esc(x.url)+'#restock-'+encodeURIComponent(x.handle)+'" aria-label="'+esc(label+(x.artist||'')+' '+(x.name||x.title||''))+'">RESTOCK</a>';
    }
    return '<button type="button" class="mf-saved__cart" data-mf-saved-cart data-variant-id="'+esc(x.variantId)+'" data-handle="'+esc(x.handle)+'">CART</button>';
  }
  function render(){
    if(!list) return;
    var items=enrichFromDOM(read());
    if(!items.length){
      list.innerHTML='<p class="mf-saved__empty">'+(document.documentElement.lang.indexOf('ja')===0?'保存したレコードはまだありません。':'No saved records yet.')+'</p>';
      return;
    }
    list.innerHTML=items.map(function(x){
      var artist=x.artist||'';
      var name=x.name||x.title||'';
      var image=x.image?'<a href="'+esc(x.url)+'"><img class="mf-saved__image" src="'+esc(x.image)+'" alt="" width="76" height="76"></a>':'<span class="mf-saved__image"></span>';
      var selected=x.selected?'<p class="mf-saved__selected">MF SELECTED</p>':'';
      var listen=x.listen?'<button type="button" class="mf-saved__listen mf-play__btn" data-listen="'+esc(x.listen)+'" data-product-title="'+esc(x.title)+'" data-product-url="'+esc(x.url)+'" data-product-handle="'+esc(x.handle)+'" data-product-image="'+esc(x.image)+'"><svg viewBox="0 0 10 10" aria-hidden="true"><path d="M1.5 1 8.5 5 1.5 9z"/></svg><span>LISTEN</span></button>':'';
      return '<article class="mf-saved__item" data-mf-saved-item="'+esc(x.handle)+'">'+image+
        '<div class="mf-saved__content">'+selected+'<p class="mf-saved__artist">'+esc(artist)+'</p><p class="mf-saved__name">'+esc(name)+'</p>'+
        (x.label?'<p class="mf-saved__label">'+esc(x.label)+'</p>':'')+
        '<div class="mf-saved__actions">'+listen+'<a class="mf-saved__view" href="'+esc(x.url)+'">VIEW</a>'+
        '<button type="button" class="mf-saved__remove" data-mf-saved-remove="'+esc(x.handle)+'">REMOVE</button></div></div>'+
        cartControl(x)+'</article>';
    }).join('');
    hydrateMissing(items);
  }
  function setItemAvailability(handle,available){
    var items=read(), changed=false;
    items.forEach(function(x){
      if(x && x.handle===handle && x.available!==available){x.available=available;changed=true;}
    });
    if(changed) write(items);
  }
  function addSavedToCart(btn){
    if(!btn || btn.disabled) return;
    var variant=btn.getAttribute('data-variant-id');
    var handle=btn.getAttribute('data-handle')||'';
    if(!variant) return;
    var original=btn.textContent;
    btn.disabled=true;
    btn.classList.add('is-loading');
    btn.textContent='…';
    fetch('/cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      body:JSON.stringify({id:Number(variant),quantity:1})
    }).then(function(res){
      if(!res.ok) return res.json().catch(function(){return {};}).then(function(err){var e=new Error(err.description||'Cart error');e.status=res.status;throw e;});
      return res.json();
    }).then(function(item){
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      btn.textContent='ADDED';
      document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem',{detail:{item:item}}));
      setTimeout(function(){
        var cartDrawer=document.querySelector('[data-cart-drawer]');
        if(cartDrawer && window.Spruce){
          try{Spruce.store('drawer').cartDrawerOpen=true;}catch(e){}
        }
      },80);
      setTimeout(function(){
        if(!btn.isConnected) return;
        btn.disabled=false;
        btn.classList.remove('is-added');
        btn.textContent=original;
      },1400);
    }).catch(function(error){
      btn.disabled=false;
      btn.classList.remove('is-loading');
      if(error && error.status===422){
        setItemAvailability(handle,false);
        render();
      }else{
        btn.textContent='RETRY';
        setTimeout(function(){if(btn.isConnected) btn.textContent=original;},1600);
      }
    });
  }

  function open(btn){
    if(!drawer) return;
    opener=btn||null; render(); syncButtons();
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); document.body.classList.add('mf-saved-open');
    if(closeBtn) requestAnimationFrame(function(){closeBtn.focus();});
  }
  function close(restore){
    if(!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true'); document.body.classList.remove('mf-saved-open');
    if(restore!==false && opener && document.documentElement.contains(opener)){try{opener.focus();}catch(e){}}
    opener=null;
  }

  document.addEventListener('click',function(e){
    var save=e.target.closest && e.target.closest('[data-mf-save]');
    if(save){e.preventDefault();e.stopPropagation();toggle(save);return;}
    var openBtn=e.target.closest && e.target.closest('[data-mf-saved-open]');
    if(openBtn){e.preventDefault();open(openBtn);return;}
    var cart=e.target.closest && e.target.closest('[data-mf-saved-cart]');
    if(cart){e.preventDefault();e.stopPropagation();addSavedToCart(cart);return;}
    var remove=e.target.closest && e.target.closest('[data-mf-saved-remove]');
    if(remove){e.preventDefault();remove && window.setTimeout(function(){},0); var h=remove.getAttribute('data-mf-saved-remove'); if(h) window.__mfSavedRemove(h); return;}
    var closeEl=e.target.closest && e.target.closest('[data-mf-saved-close]');
    if(closeEl){e.preventDefault();close(true);}
  },true);

  window.__mfSavedRemove=remove;

  document.addEventListener('keydown',function(e){if(e.key==='Escape' && drawer && drawer.classList.contains('is-open')){e.preventDefault();close(true);}});
  document.addEventListener('mf:softnav',function(){close(false);syncButtons();});
  window.addEventListener('storage',function(e){if(e.key===KEY) syncButtons();});

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',syncButtons,{once:true});
  else syncButtons();
})();
